export default __webpack_public_path__ + "static/media/icon_align_large_on.5a49661c.svg";